
import * as ReactDOM from 'react-dom/client';
import * as React from "react";
import Viewer from "./viewer/Viewer";

const container:Element = document.getElementById("3dviewer");
const root:ReactDOM.Root = ReactDOM.createRoot(container!);

const App = ():React.ReactElement =>
{
	const url:string = container.attributes["data-Url"].nodeValue;
	
	
	
	return (<>
		<div>
			<Viewer url={url} />
		</div>
	</>);
}
export default App;
root.render(<App />);